export default "__VITE_ASSET__KDIeTGHk__"